function Error () {
  return (
    <div className="error-title">
      <h2>
        Something went wrong
      </h2>
    </div>
  )
}

export default Error